const welcome = {
    title: 'Bienvenido a la Consola de Administración',
    description: 'La consola de administración es una aplicación web para administrar Logto sin necesidad de conocimientos de programación. Primero creamos una cuenta. Con esta cuenta, puedes administrar Logto por ti mismo o en nombre de tu empresa.',
    create_account: 'Crear cuenta',
};
export default welcome;
